import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  contentPanel: {
    minHeight: '75px',
    boxShadow: tokens.shadow4,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    backgroundColor: tokens.colorNeutralBackground1,
    marginBottom: tokens.spacingVerticalMNudge,
    display: 'flex',
    flexDirection: 'column',
    '& .card-header': {
      ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
      '& svg:first-child': {
        width: '24px',
        height: '24px',
      },
    },
    '& h3': {
      ...typographyStyles.body1Strong,
      marginTop: tokens.spacingVerticalXL,
      marginBottom: tokens.spacingVerticalS,
    },
    '& p': {
      ...typographyStyles.body1,
      marginTop: '0px',
      marginBottom: tokens.spacingVerticalS,
    },
  },
  contentPanelTitle: {
    ...typographyStyles.body1Strong,
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalS,
  },
  contentPanelSubtitle: {
    ...typographyStyles.body1,
    marginBottom: tokens.spacingVerticalS,
  },
  contentPanelHeader: {
    lineHeight: tokens.lineHeightBase300,
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalMNudge,
  },
  contentPanelSubheader: {
    marginBottom: tokens.spacingVerticalMNudge,
  },
});

export const getSkeletonStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: tokens.spacingVerticalL,
    ...shorthands.gap(tokens.spacingVerticalS),
  },
});
